const CACHE = new Map();

export const REFERRAL_STORAGE_KEY = 'referralLinkCode';
export const REFERRAL_STORAGE_VERSION = 1;
export const STORAGE_SCHEMA_VERSION = 1;

export function readStorage(key) {
  if (CACHE.has(key)) return CACHE.get(key);
  try {
    const value = window.localStorage.getItem(key);
    CACHE.set(key, value);
    return value;
  } catch {
    return null;
  }
}

export function writeStorage(key, value) {
  CACHE.set(key, value);
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* storage unavailable (private mode, quota, etc.) */
  }
}

export function removeStorage(key) {
  CACHE.delete(key);
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* storage unavailable */
  }
}

export function readVersionedStorage(key) {
  const raw = readStorage(key);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    if (parsed && parsed.v === STORAGE_SCHEMA_VERSION) {
      return parsed.value ?? null;
    }
  } catch {
    /* legacy plain-string value */
  }

  return raw;
}

export function writeVersionedStorage(key, value) {
  writeStorage(
    key,
    JSON.stringify({ v: STORAGE_SCHEMA_VERSION, value })
  );
}

export function readReferralCode() {
  const raw = readStorage(REFERRAL_STORAGE_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    if (parsed && parsed.v === REFERRAL_STORAGE_VERSION) {
      return typeof parsed.code === 'string' ? parsed.code : null;
    }
  } catch {
    /* legacy plain-string value */
  }

  return raw;
}

export function writeReferralCode(code) {
  writeStorage(
    REFERRAL_STORAGE_KEY,
    JSON.stringify({ v: REFERRAL_STORAGE_VERSION, code })
  );
}

export function clearReferralCode() {
  removeStorage(REFERRAL_STORAGE_KEY);
}
